import React, {useEffect, useState, Fragment} from 'react';
import {Col, Row} from 'react-bootstrap';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

import {service as OfflineDataService} from "../../../Services/OfflineDataService";
import {service as SampleEventService} from "../../../Services/SampleEventService";
import {
    usePatchContext,
} from "../../../Hooks/RouteHooks";
import {
    useMakePageRequest
} from "../../../Hooks/RequestHooks";
import {
    usePermission
} from "../../../Hooks/PermissionHooks";
import {NoPhotoIcon} from "../../Common/NoPhotoIcon";
import {StreamBankLink} from "../../Common/StreamBankLink";
import {SbMap} from "../../Common/SbMap";

export const PhotoMonitoring = (props) => {
    const {sampleEvent} = props;
    
    const makePageRequest = useMakePageRequest();
    const patchContext = usePatchContext();
    const permission = usePermission();

    const [photoPoints, setPhotoPoints] = useState(null);
    const [cameraPoints, setCameraPoints] = useState([]);

    const contextNodeDetails = sampleEvent?.ConservationActionSampleEvents?.[0]?.ConservationAction?.ContextNodeDetails;

    useEffect(() => {
        loadData();
    }, []);

    const loadData = async () => {
        if(!contextNodeDetails?.projectContextNodeId) {
            setPhotoPoints([]);
            setCameraPoints([]);
            return;
        }
        
        makePageRequest(
            _ => OfflineDataService.Download(contextNodeDetails?.projectContextNodeId, contextNodeDetails.projectId, null, true),
            ({CameraPoints = [], Photos = []}) => {
                let availablePhotoPoints = [];

                CameraPoints.forEach(cameraPoint => {
                    cameraPoint.PhotoPoints.forEach(photoPoint => {
                        availablePhotoPoints = [...availablePhotoPoints, {
                            ...photoPoint,
                            name: `${cameraPoint.name}${photoPoint.name}`,
                            photoCount: Photos.reduce(
                                (carry, p, i) =>
                                    carry + (( Number(p.sampleEventId) === Number(sampleEvent.sampleEventId) && Number(p.photoPointId) === Number(photoPoint.photoPointId) ) ? 1 : 0)
                            , 0)
                        }]
                    })
                });

                setPhotoPoints(availablePhotoPoints);
                setCameraPoints(CameraPoints);
            }
        );
    };

    return (
        <Row className="sb-photo-point-list">
            <Col xs={12} className="sb-photo-point-list-node">
                <h2 className="sb-children-list-title">Photo Points</h2>
                <ul>
                    {
                        photoPoints === null &&
                        "Loading..."
                    }
                    {
                        !!photoPoints?.length &&
                        photoPoints?.map(photoPoint => (
                            <li key={photoPoint.photoPointId}>
                                <StreamBankLink
                                    Context={patchContext({
                                        sampleEvent: null,
                                        conservationAction: null,
                                    })}
                                    Tool={`photos`}
                                    ToolParam={{
                                        photoPointId: photoPoint.photoPointId,
                                        leftSampleEventId: sampleEvent.sampleEventId,
                                }}
                                >
                                    Photo Point {photoPoint.name}
                                    { photoPoint.photoCount ? '' : <span> <NoPhotoIcon/></span> }
                                </StreamBankLink>
                            </li>
                        ))
                    }
                    {
                        photoPoints?.length === 0 &&
                        <span className="no-data-message">No Photo Points.</span>
                    }
                </ul>
            </Col>
            {
                sampleEvent && permission('run_report_sample') ?
                <div className="sb-list-actions">
                    <h2 className="sb-children-list-title">Actions</h2>
                    <ul>
                        <li>
                            <StreamBankLink
                                className={`link-primary ${!SampleEventService.SampleEventReportIsSupported(sampleEvent) ? 'disabled' : ''}`}
                                Href={SampleEventService.SampleEventReportURL(sampleEvent)}>
                                <FontAwesomeIcon icon={['fas', 'file']} />
                                <span style={{marginLeft: 6}}>Generate Report</span>
                            </StreamBankLink>
                        </li>
                    </ul>
                </div>:null
            }
            {
                !!cameraPoints.length &&
                <Col xs={12} className="sb-photo-point-list-node">
                    <h2 className="sb-children-list-title">Camera Point Locations</h2>
                    <SbMap
                        Lat={cameraPoints[0].latitude}
                        Lng={cameraPoints[0].latitude}
                        Zoom={11}
                        Markers={cameraPoints.map(point => ({
                            key: point.cameraPointId,
                            lat: point.latitude,
                            lng: point.longitude,
                            accuracy: point.accuracy,
                            marker: !permission('authenticated_user') ? 'circle' : 'both',
                            content: <div>Camera Point {point.name}</div>
                        }))}
                    />
                </Col>
            }
        </Row>
    )
};


